import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../api/client';

export default function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('idle'); // idle | loading | done | error
  const [message, setMessage] = useState('');

  const handleUnsubscribe = async () => {
    if (!token) {
      setStatus('error');
      setMessage('유효하지 않은 링크입니다.');
      return;
    }
    setStatus('loading');
    try {
      await api.post('/api/public/unsubscribe', { token });
      setStatus('done');
      setMessage('구독이 해지되었습니다. 더 이상 새 글 알림을 받지 않습니다.');
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.message || '구독 해지 중 오류가 발생했습니다.');
    }
  };

  if (!token) {
    return (
      <div className="confirm-page">
        <div className="confirm-error">
          <h2>유효하지 않은 링크</h2>
          <p>올바른 구독 해지 링크를 사용해 주세요.</p>
          <Link to="/">홈으로 돌아가기</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="confirm-page">
      {status === 'idle' && (
        <div className="unsubscribe-box">
          <h2>구독 해지</h2>
          <p>Hobbygom Blog 새 글 알림 구독을 해지하시겠습니까?</p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '24px' }}>
            <button onClick={handleUnsubscribe} className="btn-danger-full">
              구독 해지하기
            </button>
            <Link to="/" className="btn-secondary">취소</Link>
          </div>
        </div>
      )}

      {status === 'loading' && <p>처리 중...</p>}

      {status === 'done' && (
        <div className="confirm-success">
          <h2>구독 해지 완료</h2>
          <p>{message}</p>
          <Link to="/" className="btn-primary">블로그 홈으로</Link>
        </div>
      )}

      {status === 'error' && (
        <div className="confirm-error">
          <h2>오류</h2>
          <p>{message}</p>
          <Link to="/">홈으로 돌아가기</Link>
        </div>
      )}
    </div>
  );
}
